import gql from 'graphql-tag';

export const customerFragment = gql`
  fragment customer on Customer {
    id
    email
    firstName
    lastName
    fullName
    mobilePhone
    phone
    picture
    loyaltyPoints
  }
`;

export const UPDATE_ORDER = gql`
  mutation updateOrder($input: UpdateOrderInput!) {
    updateOrder(input: $input) {
      order {
        id
        customer {
          ...customer
        }
      }
      errors
    }
  }
  ${customerFragment}
`;
